module.exports = __webpack_public_path__ + "static/img/addressManagement.e470bfc.png";


//////////////////
// WEBPACK FOOTER
// ./src/view/shopping/images/addressManagement.png
// module id = BYzZ
// module chunks = 21